import { render, staticRenderFns } from "./AnnotateLabels.vue?vue&type=template&id=1d4b8f7a&scoped=true"
import script from "./AnnotateLabels.vue?vue&type=script&lang=js"
export * from "./AnnotateLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4b8f7a",
  null
  
)

export default component.exports